import { useHistory } from "react-router-dom";
import queryString from "query-string";

export const useSearchObject = () => {
  const history = useHistory();
  const searchObject = queryString.parse(history.location.search);
  return searchObject;
};
